import { checkQuestionnaireCondition } from '@shakkerai/services';
import { eventHowxm } from 'howxm-js';

export const checkAndPopNps = () => {
  // 弹出问卷
  // 检查是否满足问卷条件，满足则弹出弹窗
  checkQuestionnaireCondition().then((result) => {
    if (result) {
      setTimeout(() => {
        // 生图完成事件，必要通过?howxm_debug=true开启调试
        eventHowxm('generate_image_done', {});
        console.info(`openHowxm generate_image_done`);
      }, 0);
    }
    console.info(`checkQuestionnaireCondition result`, result);
  });
};
